import React from "react";

/**
 * Mind. Body. Soul. — Signature mark
 * Three overlapping mountain peaks with a wordmark below.
 * Rendered as inline SVG for crispness at any size.
 */
export const Logo = ({ className = "", showWordmark = true, ...props }) => {
  return (
    <svg
      viewBox="0 0 240 120"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Mind. Body. Soul."
      {...props}
    >
      <defs>
        <linearGradient id="mbs-silver" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#F5F5F7" />
          <stop offset="45%" stopColor="#C9CBD0" />
          <stop offset="100%" stopColor="#8A8D93" />
        </linearGradient>
        <filter id="mbs-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="1.2" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Three peaks — outlined, layered, faceted */}
      <g
        transform="translate(120 46)"
        stroke="url(#mbs-silver)"
        strokeWidth="1.4"
        strokeLinejoin="round"
        strokeLinecap="round"
        fill="none"
        filter="url(#mbs-glow)"
      >
        {/* Left peak */}
        <path d="M -56 26 L -30 -14 L -10 14 L -18 26 Z" opacity="0.85" />
        {/* Right peak */}
        <path d="M 56 26 L 30 -14 L 10 14 L 18 26 Z" opacity="0.85" />
        {/* Center dominant peak */}
        <path d="M -34 26 L 0 -30 L 34 26 Z" />
        {/* Inner facet lines */}
        <path d="M 0 -30 L -8 -6 L 8 -6 Z" opacity="0.9" />
        <path d="M 0 -30 L 0 26" opacity="0.5" />
        <path d="M -8 -6 L -34 26" opacity="0.6" />
        <path d="M 8 -6 L 34 26" opacity="0.6" />
        {/* Baseline */}
        <path d="M -60 26 L 60 26" opacity="0.4" />
      </g>

      {showWordmark && (
        <g
          transform="translate(120 96)"
          textAnchor="middle"
          fill="url(#mbs-silver)"
          fontFamily="'Inter', sans-serif"
          fontWeight="500"
          letterSpacing="0.32em"
          fontSize="9.5"
        >
          <text>MIND. BODY. SOUL.</text>
        </g>
      )}
    </svg>
  );
};

export default Logo;
